import {
  Session,
  ValidateSessionSuccessPayload,
} from "../../types/session.definition";
import {
  requestGetSession,
  requestTerminateSession,
  requestValidateSession,
} from "../../webclients/session.client";

export const sessionApi = {
  validateSession: async (): Promise<ValidateSessionSuccessPayload> => {
    const response = await requestValidateSession();

    return response.data;
  },

  getSession: async (): Promise<Session> => {
    const response = await requestGetSession();

    return response.data;
  },

  terminateSession: async (): Promise<void> => {
    await requestTerminateSession();
  },
};
